// extracted by mini-css-extract-plugin
module.exports = {"contain":"loadMore_contain__qc_F1","resultText":"loadMore_resultText__6hiHL","whitespace":"loadMore_whitespace__Ulvya"};